module.exports = __webpack_public_path__ + "img/histogram_selected.6d27ce6c.png";